export const classNames = (...classes: string[]) => {
    return classes.filter(Boolean).join(" ");
};

export const Colors = { PRIMARY: "primary", SECONDARY: "secondary", TERTIARY :"tertiary" } as const;
export type Color = typeof Colors[keyof typeof Colors];